// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-smart-loader {
  display: flex;
  flex: 1;
  align-self: center;
  justify-self: center;
}
.dl-smart-loader_disableStretch {
  flex: 0;
}
.dl-smart-loader__container {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/SmartLoader/SmartLoader.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,OAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACI,OAAA;AACR;AAEI;EACI,aAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;AAAR","sourcesContent":[".dl-smart-loader {\n  display: flex;\n  flex: 1;\n  align-self: center;\n  justify-self: center;\n}\n.dl-smart-loader_disableStretch {\n  flex: 0;\n}\n.dl-smart-loader__container {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
